export default theme => ({
  selectedRow: {
    backgroundColor: theme.palette.userSecondary.dark,
  },
  scoreboardTemplate_thumbnail: {
    border: "1px solid",
    cursor: "pointer",
    maxWidth: 250,
    height: "auto",
  },
  scoreboardTemplate_preview: {
    border: "1px solid",
    height: "100%",
    width: "auto",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  paginatedtable: {
    overflow: "auto",
  },
});
